import * as React from 'react';

import { noop } from 'bones/utils/noop';

export type DataCatalogQueryContextValue = [
  string,
  React.Dispatch<React.SetStateAction<string>>
];

export const DataCatalogQueryContext =
  React.createContext<DataCatalogQueryContextValue>(['', noop]);

export const useDataCatalogQuery = () => {
  const query = React.useContext(DataCatalogQueryContext);
  return query;
};

export const DataCatalogQueryProvider: React.VFC<{
  children: React.ReactNode;
  initialValue?: string;
}> = ({ children, initialValue }) => {
  const dataCatalogQuery = React.useState<string>(initialValue || '');
  return (
    <DataCatalogQueryContext.Provider value={dataCatalogQuery}>
      {children}
    </DataCatalogQueryContext.Provider>
  );
};
